import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-motor-site-announcement',
  templateUrl: './motor-site-announcement.component.html',
  styleUrls: ['./motor-site-announcement.component.scss']
})
export class MotorSiteAnnouncementComponent {

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  accessNewSite(): void {
    this.activeModal.close('redirect');
  }
}